<template>
  <!-- <el-container>
    <el-header height="100px">
      <Header />
    </el-header>
    <el-main>
      <app-main />
    </el-main>
    <el-footer>
      <Footer />
    </el-footer>
  </el-container> -->
  <div class="mBodyMap">
    <div class="headerContainer">
      <Header />
    </div>
    <div class="mainContainer">
      <app-main />
    </div>
    <div class="footerContainer">
      <Footer />
    </div>
    <div class="footerBlock" />
  </div>
</template>

<script>
// import { AppMain, Header } from './components';
import { AppMain, Header, Footer } from './components'
// import Header from './components/Header';

export default {
  components: {
    Header,
    AppMain,
    Footer
  }
}
</script>

<style lang="less">
//  .el-header {
//    border-bottom: 1px solid #2c3e50;
//    box-shadow: 0 1px #adcceb;
//    position: fixed;
//    top: 0;
//    left: 0;
//    z-index: 1500;
//    width: 100%;
//  }
//  .el-main {
//    background-color: #CEE8E8;
//    padding-bottom: 42px;
//    min-height: 1130px;
//    flex-grow:1;
//    position: fixed;
//    top: 100px;
//    width: 100%;
//  }
//  .el-footer {
//    position: ;
//    bottom: 0;
//    width: 100%;
//  }
 .headerContainer {
   width: 100%;
   border-bottom: 1px solid #2c3e50;
   box-shadow: 0 1px #adcceb;
   position: fixed;
   top: 0;
   z-index: 1500;
   background-color: #fff;
 }
 .mainContainer {
   //background-color: #CEE8E8;
   background-color: #FFFFFF;
   padding-top: 30px;
   padding-bottom: 42px;
   min-height: 1400px;
   width: 100%;
   position: absolute;
   top: 101px;
 }
 .footerContainer {
   width: 100%;
   position: fixed;
   bottom: 0;
   background-color: #fff;
 }
 .footerBlock {
   width: 100%;
   height: 100px;
 }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue